import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/AppContextProvider'
import { SalesType } from '../../util/constants'
import { detectMacOs, detectNumberCount, formatAndRoundPrize } from '../../util/util'
import MobileNumber from './MobileNumber'
import OtpNumber from './OtpNumber'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import PurchaseConfirm from './PurchaseConfirm'
import NICNumber from './NICNumber'
import PurchaseComplete from './PurchaseComplete'
import CountDown from '../../components/CountDown'
import 'bootstrap/dist/css/bootstrap.min.css'
import lotterySL from '../../assets/images/bk/lucky1sllottory.png'
import { Button } from 'reactstrap'
// for release version package.json version used
const packageJson = require('../../../package.json')
const LottoBaseHome = () => {
  const [lotteryConfig, setLotteryConfig] = useState({})
  const { setLotteryState, setPackageState, setSalesType } = useContext(AppContext)
  const { globalLoader } = useContext(MessageHandlerContext)
  const { authState } = useContext(AuthContext)
  const {
    mobileNumberModal, setMobileNumberModal,
    otpModal, setOtpModal,
    nicModal, setNicModal,
    purchaseCompleteModal, setPurchaseCompleteModal,
    purchaseConfirmModal, setPurchaseConfirmModal
  } = useContext(ModalContext)

  const [isLotterySL, setIsLotterySL] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const ref = urlParams.get('ref')
    if (ref && ref.toLowerCase().startsWith('lotterysl')) {
      setIsLotterySL(true)
    }
    console.log(isLotterySL)
    // Define the configuration for each lottery
    const lotteries = {
      Govi_Setha: {
        themeState: 'gs',
        lottoName: 'Govi_Setha',
        jackpotPrice: window.env.GS_JACKPOT_PRICE,
        drawId: window.env.GS_DRAW_ID,
        draw_number: window.env.GS_DRAW,
        drawDate: window.env.GS_DRAW_DATE,
        draw_date_time: window.env.GS_DRAW_END_TIME,
        packageId: window.env.GS_PACKAGE_ID
      },
      Mahajana_Sampatha: {
        themeState: 'ms',
        lottoName: 'Mahajana_Sampatha',
        jackpotPrice: window.env.MS_JACKPOT_PRICE,
        drawId: window.env.MS_DRAW_ID,
        draw_number: window.env.MS_DRAW,
        drawDate: window.env.MS_DRAW_DATE,
        draw_date_time: window.env.MS_DRAW_END_TIME,
        packageId: window.env.MS_PACKAGE_ID
      },
      Dhana_Nidhanaya: {
        themeState: 'dn',
        lottoName: 'Dhana_Nidhanaya',
        jackpotPrice: window.env.DN_JACKPOT_PRICE,
        drawId: window.env.DN_DRAW_ID,
        draw_number: window.env.DN_DRAW,
        drawDate: window.env.DN_DRAW_DATE,
        draw_date_time: window.env.DN_DRAW_END_TIME,
        packageId: window.env.DN_PACKAGE_ID
      },
      Hadahana: {
        themeState: 'hd',
        lottoName: 'Hadahana',
        jackpotPrice: window.env.HD_JACKPOT_PRICE,
        drawId: window.env.HD_DRAW_ID,
        draw_number: window.env.HD_DRAW,
        drawDate: window.env.HD_DRAW_DATE,
        draw_date_time: window.env.HD_DRAW_END_TIME,
        packageId: window.env.HD_PACKAGE_ID
      },
      Ada_Sampatha: {
        themeState: 'as',
        lottoName: 'Ada_Sampatha',
        jackpotPrice: window.env.AS_JACKPOT_PRICE,
        drawId: window.env.AS_DRAW_ID,
        draw_number: window.env.AS_DRAW,
        drawDate: window.env.AS_DRAW_DATE,
        draw_date_time: window.env.AS_DRAW_END_TIME,
        packageId: window.env.AS_PACKAGE_ID
      },
      Mega_Power: {
        themeState: 'mp',
        lottoName: 'Mega_Power',
        jackpotPrice: window.env.MP_JACKPOT_PRICE,
        drawId: window.env.MP_DRAW_ID,
        draw_number: window.env.MP_DRAW,
        drawDate: window.env.MP_DRAW_DATE,
        draw_date_time: window.env.MP_DRAW_END_TIME,
        packageId: window.env.MP_PACKAGE_ID
      },
      NLB_Jaya: {
        themeState: 'nj',
        lottoName: 'NLB_Jaya',
        jackpotPrice: window.env.NJ_JACKPOT_PRICE,
        drawId: window.env.NJ_DRAW_ID,
        draw_number: window.env.NJ_DRAW,
        drawDate: window.env.NJ_DRAW_DATE,
        draw_date_time: window.env.NJ_DRAW_END_TIME,
        packageId: window.env.NJ_PACKAGE_ID
      },
      Subha_Dawasak: {
        themeState: 'sd',
        lottoName: 'Subha_Dawasak',
        jackpotPrice: window.env.SD_JACKPOT_PRICE,
        drawId: window.env.SD_DRAW_ID,
        draw_number: window.env.SD_DRAW,
        drawDate: window.env.SD_DRAW_DATE,
        draw_date_time: window.env.SD_DRAW_END_TIME,
        packageId: window.env.SD_PACKAGE_ID
      }

    }
    setLotteryState(lotteries)
    setLotteryConfig(lotteries)
  }, [])
  const onBuyClick = (type, packageId) => {
    setPackageState(packageId)
    setSalesType(type)
    if (authState && authState.token) {
      setPurchaseConfirmModal(!purchaseConfirmModal)
    } else {
      setMobileNumberModal(!mobileNumberModal)
    }
  }
  const renderLottery = (lottoName) => {
    const config = lotteryConfig[lottoName]
    if (!config) return null
    const formattedPrize = formatAndRoundPrize(config.jackpotPrice)
    const spacing = detectNumberCount(formattedPrize.amount)
    // const renderMegaPowerLottery = () => {
    //   return (
    //     <div className='row'>
    //     <div className="col-sm-6 col-md-4 col-lg-3 m-4">
    //       <div className={`lottery-wrapper main_content ${config.themeState}`}>
    //         <div className='MegapowerDrawText'>
    //           DRAW {config.draw_number} | DATE {config.drawDate}
    //         </div>
    //         <div className='MegapowerPriceText'>
    //         {formattedPrize.amount} {formattedPrize.suffix}
    //         </div>
    //         <div className='buttonforMP'>
    //           <button
    //             className='buttonInsideforMP'
    //             onClick={() => {
    //               onBuyClick(SalesType.ON_DEMAND, config.packageId)
    //             }}
    //           >
    //             BUY NOW
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //     </div>
    //   )
    // }
    // Check if the current lotto is "Mega Power"
    // if (config.lottoName === 'Mega_Power') {
    //   return renderMegaPowerLottery()
    // }
    return (
      <div className='row'>
      <div key={lottoName} className="col-sm-6 col-md-4 col-lg-3 m-4" >
        <div className={`lottery-wrapper main_content ${config.themeState}`}>
          <div className={`winning-prize-wrapper ${config.themeState}`}>
            {spacing !== 0 && <div className='winning-prize-currency' style={{ top: spacing.top, left: spacing.left }}>Rs</div>}
            <div className='draw-info'>
              DRAW {config.draw_number} | DATE {config.drawDate}
            </div>
            <div className={`winning-prize-amount ${config.themeState}`} style={{ top: detectMacOs() ? -22 : -7 }}>
              {formattedPrize.amount}
            </div>
            <div className='winning-prize-suffix' style={{ bottom: detectMacOs() ? -16 : -22 }}>
              {formattedPrize.suffix}
            </div>
          </div>
          <div className='countdown-wraper-container'>
            <CountDown LotteryName ={config.lottoName}/>
          </div>
          <div className={'button'}>
            <button
              className={`buy-button ${config.themeState}`}
              style={{ paddingTop: detectMacOs() ? 2 : 4 }}
              onClick={() => {
                onBuyClick(SalesType.ON_DEMAND, config.packageId)
              }}
            >
              BUY NOW
            </button>
          </div>
        </div>
      </div>
      </div>
    )
  }

  return (
    <>
      <div className='fluid-container'>
        {isLotterySL && (
          <div className='header-bar d-flex flex-column align-items-center justify-content-center text-center'>
            <img
              src={lotterySL}
              alt='Lottery SL'
              className='lottery-logo mb-3'
            />

            <Button
              color='primary'
              style={{ padding: '4px 16px', borderRadius: '8px', fontWeight: 'normal', fontSize: '16px' }}
              onClick={() =>
                window.open('https://cpg.digitalxlabs.com/login', '_blank')
              }
            >
              Manage Your Payments
            </Button>
          </div>
        )}
        {!globalLoader && renderLottery()}
        {!globalLoader &&
          Object.keys(lotteryConfig).map((lottoName) =>
            renderLottery(lottoName)
          )}
        <MobileNumber
          opened={mobileNumberModal}
          toggle={() => setMobileNumberModal(!mobileNumberModal)}
        />
        <OtpNumber opened={otpModal} toggle={() => setOtpModal(!otpModal)} />
        <NICNumber opened={nicModal} toggle={() => setNicModal(!nicModal)} />
        <PurchaseConfirm
          opened={purchaseConfirmModal}
          toggle={() => setPurchaseConfirmModal(!purchaseConfirmModal)}
        />
        <PurchaseComplete
          iscollection={true}
          opened={purchaseCompleteModal}
          toggle={() => setPurchaseCompleteModal(!purchaseCompleteModal)}
        />
      </div>
      <footer className='footer'>
        <div className='fluid-container'>
          <span className='small text-muted'>v-{packageJson.version}</span>
        </div>
      </footer>
    </>
  )
}

export default LottoBaseHome
